"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const errors_1 = require("./errors");
const types_1 = require("./types");
let ToolService = class ToolService {
    constructor(loggerService, traceService, toolPrefix, requireDriver, containerFactory) {
        this.toolPrefix = toolPrefix;
        this.requireDriver = requireDriver;
        this.loggerService = loggerService;
        this.containerFactory = containerFactory;
        traceService.track(this);
    }
    getTool(toolName) {
        const containerModule = this.getToolContainerModule(toolName);
        return {
            register: (gulp, taskName, parameters) => {
                try {
                    const container = this.containerFactory();
                    container.bind(urbanjs_tools_core_1.TYPE_DRIVER_GULP).toConstantValue(gulp);
                    container.load(containerModule);
                    container.get(urbanjs_tools_core_1.TYPE_TOOL).register(taskName, parameters);
                }
                catch (e) {
                    if (!(e instanceof errors_1.UrbanjsToolsError)) {
                        this.loggerService.error('Unexpected error\n', e);
                    }
                    throw e;
                }
            }
        };
    }
    getToolContainerModule(name) {
        const logPrefix = 'ToolService.getToolContainerModule';
        const packageName = `${this.toolPrefix}${name}`;
        try {
            this.loggerService.debug(logPrefix, `loading ${packageName}`);
            return this.requireDriver.require(packageName).containerModule;
        }
        catch (e) {
            this.loggerService.debug(logPrefix, 'tool not found', name, e);
        }
        try {
            this.loggerService.debug(logPrefix, `loading ${name}`);
            return this.requireDriver.require(name).containerModule;
        }
        catch (e) {
            this.loggerService.error(`Tool was not found: ${name}. Please install ${packageName}.`, e);
            throw new errors_1.NotFoundTool();
        }
    }
};
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Object)
], ToolService.prototype, "getTool", null);
ToolService = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_LOGGER)),
    __param(1, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_TRACE)),
    __param(2, inversify_1.inject(types_1.TYPE_CONFIG_TOOL_PREFIX)),
    __param(3, inversify_1.inject(types_1.TYPE_DRIVER_REQUIRE)),
    __param(4, inversify_1.inject(types_1.TYPE_FACTORY_TOOL_CONTAINER)),
    __metadata("design:paramtypes", [Object, Object, String, Object, Function])
], ToolService);
exports.ToolService = ToolService;
